import { render } from "./CoverList.vue?vue&type=template&id=7f23579a&scoped=true"
import script from "./CoverList.vue?vue&type=script&lang=js"
export * from "./CoverList.vue?vue&type=script&lang=js"

import "./CoverList.vue?vue&type=style&index=0&id=7f23579a&scoped=true&lang=css"
import "./CoverList.vue?vue&type=style&index=1&id=7f23579a&lang=css"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f23579a"]])

export default __exports__